// extracted by mini-css-extract-plugin
module.exports = {"chartPlaceHolder":"Parking_chartPlaceHolder__31Ph9","chartLegend":"Parking_chartLegend__1lDz-"};